export default __webpack_public_path__ + "static/media/kitchen3-afterF-2048w.79891518.webp";